import React, { useState, Fragment } from "react"
import { MdClose } from "react-icons/md"
import { FaDownload, FaTrashAlt } from "react-icons/fa"
import { LiaEditSolid } from "react-icons/lia"
import { TbDotsVertical } from "react-icons/tb"
import { useTranslation } from "react-i18next"
import { Dropdown, MenuItem } from "react-bootstrap"

import { ConfirmationModal, IconButton, } from "components"
import classes from "./TdListCardDropdown.module.scss"
import clsx from "clsx"

const TdListCardDropdown = props => {
  const {
    table,
    setTables,
    tableIndex,
    setLayout,
    setSelectedTable
  } = props

  const [t, i18n] = useTranslation()

  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const handleDeleteTable = async () => {
    setTables(prev =>
      prev.filter(t =>
        t.tableNumber !== table.tableNumber
      )
    )
  }

  const handleEdit = () => {
    setSelectedTable({ tableIndex, ...table })

    setLayout("form")
  }

  const handleDrop = () => {
    const containerWidth =
      document.getElementById("tables-container").offsetWidth

    const containerHeight =
      document.getElementById("tables-container").offsetHeight

    setTables(prev =>
      prev.map((t, tIndex) =>
        t.tableNumber === table.tableNumber
          ?
          {
            ...t,
            available: true,
            position: {
              x: -((5 * (tIndex + 1)) / containerWidth),
              y: (45 / containerHeight)
            }
          }
          :
          t
      )
    )
  }

  const handleRemove = () => {
    setTables(prev =>
      prev.map(t =>
        t.tableNumber === table.tableNumber
          ? { ...t, available: false }
          : t
      )
    )
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <Dropdown
        id="id"
        pullRight={isLtr}
        className={classes["dropdown"]}
      >
        <Dropdown.Toggle
          noCaret
          className={classes["icon"]}
        >
          <TbDotsVertical
            size={20}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <MenuItem
            onClick={table.available ? handleRemove : handleDrop}
          >
            <div className={classes["dropdown-item"]}>
              <IconButton
                size={18}
                onClick={table.available ? handleRemove : handleDrop}
                icon={table.available ? MdClose : FaDownload}
              />

              <span
                className={clsx(
                  classes["text"],
                  isLtr && classes["text-ltr"]
                )}
              >
                {table.available ? t("حذف_از_نقشه") : t("قرار_دادن_در_نقشه")}
              </span>
            </div>
          </MenuItem>

          <MenuItem
            onClick={handleEdit}
          >
            <div className={classes["dropdown-item"]}>
              <IconButton
                size={18}
                onClick={handleEdit}
                icon={LiaEditSolid}
                color="var(--color-info)"
              />

              <span
                className={clsx(
                  classes["text"],
                  isLtr && classes["text-ltr"]
                )}
              >
                {t("ویرایش")}
              </span>
            </div>
          </MenuItem>

          <MenuItem
            onClick={() => setShowConfirmationModal(true)}
          >
            <div className={classes["dropdown-item"]}>
              <FaTrashAlt
                size={18}
                color="var(--color-danger)"
              />

              <span
                className={clsx(
                  classes["text"],
                  isLtr && classes["text-ltr"]
                )}
              >
                {t("حذف")}
              </span>
            </div>
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>

      <ConfirmationModal
        show={showConfirmationModal}
        onConfirm={handleDeleteTable}
        onHide={() => setShowConfirmationModal(false)}
        title={table.status === "ready"
          ? t("آیا_می_خواهید_میز_tableNumber_را_حذف_کنید", { tableNumber: table.tableNumber })
          : t("چندین_سفارش_روی_میز_tableNumber_ثبت_شده_آیا_می_خواهید_این_میز_را_حذف_کنید_توجه_کنید_که_سفارش_های_میز_هم_بعد_از_حذف_میز_پاک_می_شوند", { tableNumber: table.tableNumber })
        }
      />
    </Fragment>
  )
}

export default TdListCardDropdown